import type { Message } from '../../../contracts/harness.types';

/**
 * SEAM #1 — content fingerprints. Without artifact ids nothing else tells a
 * streamed or optimistic message from its persisted copy, so ingestion
 * twin-matches on these. DELETE one release after the identity contract ships
 * to production.
 */

/** Attachments excluded: an optimistic preview never matches its persisted copy. */
export const userMessageSignature = (message: Message): string =>
  message.blocks
    .filter((block) => block.kind === 'text')
    .map((block) => block.text)
    .join('\n');

export const assistantMessageSignature = (message: Message): string =>
  message.blocks
    .map((block) => {
      switch (block.kind) {
        case 'text':
        case 'thinking':
          return `${block.kind}:${block.text}`;
        case 'tool_call':
          return `tool_call:${block.id}:${block.name}`;
        case 'tool_result':
          return `tool_result:${block.tool_call_id}:${block.is_error}`;
        case 'attachment':
          return `attachment:${block.attachment_id}`;
      }
    })
    .join('|');
